import React from "react";
import { CrossIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { useDispatch } from "react-redux";

import { CustomCardHeader } from "@components/Common/CustomCardStyled";

import { AppDispatch } from "../../../../../../redux/store";
import {
    setIsActionsClicked,
    setIsEdited,
} from "../../../../../../redux/slices/fidelitySlice";
import { useFidelityNavigationGuard } from "../../../FidelityNavigationGuardContext";

type Props = {
    title: string;
    dataFidelity: any;
    isEdited: boolean;
    isActionsClicked: boolean;
    isAddFidelityClicked: boolean;
    setIsAddFidelityClicked: (v: boolean) => void;
    setDataFidelity: (rows: FidelityRow[]) => void;
    setDataIsUpdated: (v: boolean) => void;
};

export default function FormHeader({
    title,
    dataFidelity,
    isEdited,
    isActionsClicked,
    isAddFidelityClicked,
    setIsAddFidelityClicked,
    setDataFidelity,
    setDataIsUpdated,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const { setOnConfirm } = useFidelityNavigationGuard();
    const handleClose = () => {
        if (isEdited) {
            dispatch(setIsActionsClicked(!isActionsClicked));
            setOnConfirm(() => {
                dispatch(setIsEdited(false));
                setDataFidelity([]);
                setIsAddFidelityClicked(!isAddFidelityClicked);
                setDataIsUpdated(true);
            });
        } else {
            setIsAddFidelityClicked(!isAddFidelityClicked);
            dispatch(setIsEdited(false));
        }
    };

    return (
        <CustomCardHeader
            className="d-flex align-items-center justify-content-between"
            style={{ maxHeight: "76px" }}
        >
            <h5
                className={classnames("pt-3", {
                    fed_txt_FRtitleFormLoyalty: dataFidelity.Id === undefined,
                })}
            >
                {title}
            </h5>
            <CrossIcon
                className="fed_icn_FRcloseForm"
                height={13}
                width={13}
                onClick={handleClose}
            />
        </CustomCardHeader>
    );
}
